import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { UserPlus } from "lucide-react";
import AuthShell from "@/components/app/AuthShell";

export default function RegisterPage() {
  const { register, formatApiError } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await register(email, password, name);
      nav("/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <AuthShell icon={UserPlus} tint="bg-matcha/60" title={t("createAcc")} subtitle={t("trackStreak")} testId="register-card"
      footer={<div>{t("haveAccount")} <Link to="/login" className="underline font-extrabold text-ink">{t("login")}</Link></div>}>
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="register-name" type="text" required placeholder={t("yourName")} value={name} onChange={(e) => setName(e.target.value)} className="kawaii-input" />
        <input data-testid="register-email" type="email" required placeholder={t("email")} value={email} onChange={(e) => setEmail(e.target.value)} className="kawaii-input" />
        <input data-testid="register-password" type="password" required minLength={6} placeholder={t("passMin")} value={password} onChange={(e) => setPassword(e.target.value)} className="kawaii-input" />
        {error && <div data-testid="register-error" className="kawaii-chip !bg-coral/60 !text-sm !py-2 !px-4 w-full">{error}</div>}
        <button data-testid="register-submit" disabled={busy} className="kawaii-btn kawaii-btn-ink w-full !py-3.5">{busy ? "…" : t("signup")}</button>
      </form>
    </AuthShell>
  );
}
